export const sliderWatch = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-17.png'
    },
    {
        id: 2,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-16.png'
    },
    {
        id: 3,
        url: 'https://cdn.tgdd.vn/2022/07/banner/800-200-800x200-166.png'
    },
    {
        id: 4,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-28.png'
    },
    {
        id: 5,
        url: 'https://cdn.tgdd.vn/2022/08/banner/800-200-800x200-29.png'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/2022/08/banner/Layer-3-800x200.png'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/2022/08/banner/Layer-1-800x200-1.png'
    }

]
  
    
   


export const bannerWatch = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2022/06/banner/2-390x97.png'
    },
    {
        id: 2,
        url: 'https://cdn.tgdd.vn/2022/06/banner/3-390x97.png'
    }
]

export const images = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2022/06/banner/MVW-STAR-420-X-260-420x260.png'
    },
    {   
        id: 2,
        url: 'https://cdn.tgdd.vn/2021/12/banner/03-420x260.png'
    },
    {
        id: 3,
        url:'https://cdn.tgdd.vn/2022/06/banner/420-x-260-420x260.png'
    },
    {
        id: 4,
        url: 'https://cdn.tgdd.vn/2021/12/banner/02-420x260.png'
    },
    {
        id: 5,
        url: 'https://cdn.tgdd.vn/2021/12/banner/01-420x260.jpg'
    },
    {
        id: 6,
        url: 'https://cdn.tgdd.vn/2021/06/banner/01-420x260.png'
    },
    {
        id: 7,
        url: 'https://cdn.tgdd.vn/2021/12/banner/06-420x260.png'
    },
    {
        id: 8,
        url: 'https://cdn.tgdd.vn/2022/04/banner/orrient-420x260.png'
    }
]




export const listWatchProducts = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '40',
        pricenew: '1.194.000đ'
        


    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '40',
        pricenew: '1.194.000đ'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '40',
        pricenew: '1.194.000đ'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '40',
        pricenew: '1.194.000đ'
        
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '40',
        pricenew: '1.194.000đ'
        
    },
    
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '40',
        pricenew: '1.194.000đ'
        
    },
    
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/Products/Images/7264/247105/dong-ho-nam-mvw-ml064-01-1.-600x600.jpg',
        catproduct: 'MVW',
        nameproduct: 'ML064-01',
        priceold : '1.990.000đ',
        discount : '-40%',
        pricenew: '1.194.000đ'
        
    },
    
]


export const line_strap = [
    {
        id: 1,
        name: 'Đồng hồ thời trang',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050308.jpg'
    },
    {
        id: 2,
        name: 'Apple Watch',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-051259.jpg'
    },
    {
        id: 3,
        name: 'Miband',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050915.jpg'
    },
    {
        id: 4,
        name: 'Samsung Watch',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050919.jpg'
    },
    {
        id: 5,
        name: 'Huawei Watch',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/090521-050925.jpg'

    },
    {
        id: 6,
        name: 'Da tổng hợp',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/030521-113903.jpg'
    },
    {
        id: 7,
        name: 'Silicone',
        url: 'https://cdn.tgdd.vn/Category/Quicklink/7978/1/280421-091748.jpg'
    }

]

export const width_line_strap = [12,14,16,18,22]

export const WatchCategories = [
    {
        id: 1,
        title: 'Đồng hồ độc quyền',
        url: 'https://cdn.tgdd.vn/2021/05/banner/DHDocquyendesk-330x428.jpg',
        pathname: '/dong-ho-doc-quyen'
        
    },

    {
        id: 2,
        title: 'Đồng hồ cao cấp',
        url: 'https://cdn.tgdd.vn/2021/05/banner/DHCaocapDesk-330x428.png',
        pathname: '/dong-ho-cao-cap'
        
    },

    {
        id: 3,
        title: 'Đồng hồ phái mạnh',
        url: 'https://cdn.tgdd.vn/2022/03/banner/Dhnamdesk-330x428-2.png',
        pathname: '/dong-ho-danh-cho-nam',
        category: 'Đồng hồ',
        sub: 'Đồng hồ nam',
        
    },
    {
        id: 4,
        title: 'Đồng hồ phái nữ',
        url: 'https://cdn.tgdd.vn/2022/07/banner/dh-nu-desk-330x428.png',
        pathname: '/dong-ho-danh-cho-nu',
        category: 'Đồng hồ',
        sub: 'Đồng hồ nữ',
        
    },
    {
        id: 5,
        title: 'Đồng hồ cặp đôi',
        url: 'https://cdn.tgdd.vn/2022/07/banner/dh-cap-desk-330x428.png',
        pathname: '/dong-ho-cap-doi',
        category: 'Đồng hồ',
        sub: 'Đồng hồ cặp đôi',
    },
    {
        id: 6,
        title: 'Đồng hồ trẻ em',
        url: 'https://cdn.tgdd.vn/2021/04/banner/DHTreemdesktop3-330x428.jpg',
        pathname: '/dong-ho-tre-em',
        category: 'Đồng hồ',
        sub: 'Đồng hồ trẻ em',
    }

]